import { RecordBase } from '../../providers/request/record-base.model';
import { ProjectItemType } from '../project/project-item-type.enum';

export class JgLoadInsp extends RecordBase {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  sectionItemId?: number;
  sectionItemType?: ProjectItemType;
  spotChecked?: boolean;
  qualified?: boolean;
  qualifiedText?: string;
  hasReport?: boolean;
  comment?: string;
  code?: string;
  name?: string;
  codeName?: string;
  sortOrder?: number;
  dwMileage?: string;
}
